import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { fetchKaizenPoints} from "./kaizenAction.jsx";
import { getCallWithReducer, postCallWithReducer } from "./commonAction";
import { getToken } from '../oidc/AuthService';
export const ADD_MODAL = 'ADD_MODAL';

/* eslint-disable */

export function getActivityDetails(activityId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getActivityDetails/" + activityId,null,"ACTIVITY_DETAILS"))
  };
}

export function getNmscQuestionId(versionSubQuestionId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getNmscQuestionId/" + versionSubQuestionId,null,"EVALUATION_NMSC_QUESTION"))
  };
}
export function fetchEvaluationChapterSequence(chapterId, isPublished) {
  return function (dispatch) {
    if (chapterId) {
      //dispatch(setBlockingState(true));
      axios
        .get("/evaluation/evaluationChapterSeq/" + chapterId, {
          headers: {
          'Authorization': 'Bearer ' + getToken(),
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
          }
        })
        
        .then(response => {
          //dispatch(setBlockingState(false));

          dispatch({
            type: "EVALUATION_MAIN_CHAPTER_SEQ",
            payload: response.data
          });
        })
        .catch(function (error) {
          if (error && error.status && (error.status === 429)) {
          } else {
            console.error(error);
          }
        });
    }
    else {
      dispatch({
        type: "EVALUATION_MAIN_CHAPTER_SEQ",
        payload: null
      });
    }
  };
}

export function getEvaluationChapters(versionId, activityId, chapterId, questionId, firstLoadFlag, afterEvaluation) {

  return function (dispatch) {
    //dispatch(setBlockingState(true));
    axios
      .get("/evaluation/getChapters/" + versionId + "/" + activityId, {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
        }
      })
      .then(response => {
        dispatch({
          type: "FETCH_ALL_QUESTIONS",
          payload: response.data
        });
        //dispatch(setBlockingState(false));
        var nodeList = response.data;
        if (firstLoadFlag) {
          var chapt = nodeList[0];
          nodeList.map((node) => {
            node.toggled = true;
          })
          if (chapt) {
            var node = chapt.children;
            var question = node[0];
            if (question) {
              question.active = true;
              // chapt.toggled = true;
              dispatch(fetchEvaluationChapterSequence(question.mainQId));
              dispatch(getDealerMainQuestion(question.mainQId));
              dispatch(getDealerSubQuestion(question.mainQId, activityId));
            }
            else {
              //  node.toggled = true;
            }
          }
          dispatch({
            type: "FIRST_LOAD",
            payload: true
          });

        }
        else if (afterEvaluation) {
          for (var i = 0; i < nodeList?.length; i++) {
            var chapt = nodeList[i];
            if (chapt.chapterId === chapterId) {
              var node = nodeList[i].children;
              for (var j = 0; j < node?.length; j++) {
                var question = node[j];
                if (question.mainQId === questionId) {
                  question.active = true;
                }
                else {
                  question.active = false;
                }
              }
              chapt.toggled = true;
            }
            else {
              chapt.toggled = true;
            }

          }

        }
        else {
          if (chapterId && (questionId && questionId != 0)) {
            for (var i = 0; i < nodeList?.length; i++) {
              var chapt = nodeList[i];
              if (chapt.chapterId === chapterId) {
                var node = nodeList[i].children;
                for (var j = 0; j < node?.length; j++) {
                  var question = node[j];
                  if (question.mainQId === questionId) {
                    question.active = true;
                  }
                  else {
                    question.active = false;
                  }
                }
                chapt.toggled = true;
              }
              else {
                chapt.toggled = true;
              }

            }
            dispatch(fetchEvaluationChapterSequence(questionId));
            dispatch(getDealerMainQuestion(questionId));
            dispatch(getDealerSubQuestion(questionId, activityId));
          }
          else if (chapterId && !questionId) {
            for (var i = 0; i < nodeList?.length; i++) {
              var node = nodeList[i];
              if (node.chapterId === chapterId) {
                node.active = true;
              }
              else {
                node.active = false;
              }
            }
          }
          else if (questionId && questionId === 0) {
          }
          else {
            dispatch(fetchEvaluationChapterSequence(null));
          }
        }

        dispatch({
          type: "EVALUATION_CHAPTERS",
          payload: nodeList
        });

      })
      .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          console.error(error);
        }
      });
  };
}

export function getEvaluationVersion(activityId, section) {
  return function (dispatch) {
    //dispatch(setBlockingState(true));
    axios
      .get("/evaluation/getEvaluationVersion/" + activityId, {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
        }
      })
      .then(response => {
        //dispatch(setBlockingState(false));
        dispatch({
          type: "EVALUATION_VERSION",
          payload: response.data
        });
        if (response.data !== 9999) {
          // section TSM only call one api 
          if( section === 'TSM' || section === "TSM_USED_CAR" || section ==="TSM_BNP" || section === "TSM_SURVEYS"){
            dispatch(getEvaluationChapters(response.data, activityId, null, null, true));
            dispatch(getEvaluationProgressBar(activityId));
          }
          if(section === "NAS"){
            dispatch(getEvaluationChapters(response.data, activityId, null, null, true));
            dispatch(getEvaluationProgressBarForFirstAudit(activityId))
            dispatch(getEvaluationProgressBarForFirstAuditTME(activityId))
          }
          if (section === 'FIRST_AUDIT') {
            dispatch(getEvaluationChapters(response.data, activityId, null, null, true));
            //dispatch(getEvaluationProgressBar(activityId));
            dispatch(getEvaluationProgressBarForFirstAudit(activityId))
            dispatch(getEvaluationProgressBarForFirstAuditTME(activityId))
          }
          if (section === 'RE_EVALUATION') {
            dispatch(getChaptersForReEvaluation(response.data, activityId, null, null, true));
            dispatch(getReEvaluationProgressBar(activityId));
            dispatch(getReEvaluationProgressBarTME(activityId))
          }
          // dispatch(getEvaluationAnsweredByActivity(activityId));
          
        }

      })
      .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          console.error(error);
        }
      });
  };
}
/*   export function getEvaluationAnsweredByActivity(activityId) {
    return function (dispatch) {
      //dispatch(setBlockingState(true));
      axios
        .get("/evaluation/getEvaluationAnsweredByActivity/" + activityId, {
          headers: {
            Accept: "application/json",
            Pragma: "no-cache"
          }
        })
        .then(response => {
          //dispatch(setBlockingState(false));
          dispatch({
            type: "EVALUATION_ACTIVITY_COMPLETED",
            payload: response.data
          });
        })
        .catch(function (error) {
          //dispatch(setBlockingState(false));
          console.error(error);
        });
    };
  } */


export function getEvaluationProgressBar(activityId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getEvaluationProgressBar/"+ activityId,null,"EVALUATION_PROGRESSBAR"))
  };
}

export function getReEvaluationProgressBar(activityId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getEvaluationProgressBarForReEvaluation/"+ activityId,null,"RE_EVALUATION_PROGRESSBAR"))
  };
}


export function getDealerMainQuestion(questionId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getMainQuestion/" + questionId,null,"EVALUATION_MAIN_QUESTION"))
  };
}

export function getDealerSubQuestion(questionId, activityId) {
  return function (dispatch) {
    //dispatch(setBlockingState(true));
      axios
        .get("/evaluation/getSubQuestion/" + questionId + "/" + activityId, {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
        }
      })
      .then(response => {
        //dispatch(setBlockingState(false));
        var versionSubQuestionId = null;
        if (response.data.length > 0) {
          response.data.map((ele) => {
            if (ele.nmscSubQuestionId !== null && versionSubQuestionId === null) {
              versionSubQuestionId = ele.versionSubQuestionId;
            }
          })
        }
        if (versionSubQuestionId !== null) {
          dispatch(getNmscQuestionId(response.data[0].versionSubQuestionId))
        }
        dispatch({
          type: "EVALUATION_SUB_QUESTION",
          payload: response.data
        });
      })
      .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          console.error(error);
        }
      });
  };
}

export function submitEvaluation(evaluationDTO, versionId, chapterId, questionId, refreshHistory) {
  return function (dispatch) {
    let url = "/evaluation/submitEvaluation";
    axios
      .post(url, evaluationDTO, {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          "Content-type": "application/json",
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
        }
      })
      .then(response => {
        dispatch({
          type: "EVALUATION_ID",
          payload: response.data.desc
        });
        
        dispatch(fetchKaizenPoints(evaluationDTO.activityId))
     
    
        if (evaluationDTO.section === 'RE_EVALUATION') {
          dispatch(getEvaluationProgressBar(evaluationDTO.activityId, evaluationDTO.businessAreaKey));
          dispatch(getSubQuestionForReEvaluation(questionId, evaluationDTO.activityId));
          dispatch(getChaptersForReEvaluation(versionId, evaluationDTO.activityId, chapterId, questionId, false, true));
        } 
        /**This is for TSM/LSM questioneers part */
        else if(evaluationDTO.section ===  "QUESTIONNAIRE"){
          dispatch(getDealerSubQuestion(questionId, evaluationDTO.activityId));
          dispatch(getEvaluationChapters(versionId, evaluationDTO.activityId, chapterId, questionId, false, true));
          dispatch(getEvaluationProgressBar(evaluationDTO.activityId, evaluationDTO.businessAreaKey));
        }
        else {
          dispatch(getDealerSubQuestion(questionId, evaluationDTO.activityId));
          dispatch(getEvaluationChapters(versionId, evaluationDTO.activityId, chapterId, questionId, false, true));
          //dispatch(getEvaluationProgressBar(evaluationDTO.activityId, evaluationDTO.businessAreaKey));
          dispatch(getEvaluationProgressBarForFirstAudit(evaluationDTO.activityId, evaluationDTO.businessAreaKey))
          dispatch(getEvaluationProgressBarForFirstAuditTME(evaluationDTO.activityId, evaluationDTO.businessAreaKey))
        }


        if (refreshHistory) {
          dispatch(getCommentsHistory(response.data.desc));
        }
        if (evaluationDTO.section === 'FIRST_AUDIT') {
          dispatch(getEvaluationProgressBar(evaluationDTO.activityId, evaluationDTO.businessAreaKey));
          dispatch(getEvaluationProgressBarForFirstAuditTME(evaluationDTO.activityId, evaluationDTO.businessAreaKey))
        }
        else if (evaluationDTO.section === 'RE_EVALUATION') {
          dispatch(getReEvaluationProgressBar(evaluationDTO.activityId));
          dispatch(getReEvaluationProgressBarTME(evaluationDTO.activityId))
        }
        // dispatch(getEvaluationAnsweredByActivity(evaluationDTO.activityId));
      })
      .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          toastr.error("" + error);
        }
      });
  };
}

export function getCommentsHistory(evaluationId, businessArea) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/commentHistory/" + evaluationId + "/" + businessArea,null,"EVALUATION_HISTORY_COMMENT"))
  };
}

export function completeFirstAudit(completeAuditDto) {
 
  return function (dispatch) {
     axios
       .post("/activity/completeAudit", completeAuditDto,{
         headers: {
           'Authorization': 'Bearer ' + getToken(),
           Accept: "application/json",
           Pragma: "no-cache",
           "X-Frame-Options":"DENY"
         }
       })
       .then(response => {
         dispatch({
           type:"COMPLETE_AUDIT" ,
           payload:response.data
         });
          if (response.data.statusCode === "200") {
                     toastr.success("First Audit has been completed successfully");
          }
          dispatch(getEvaluationProgressBar(completeAuditDto.activityId));
          dispatch(getActivityDetails(completeAuditDto.activityId));
       })
       .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          toastr.error("" + error);
        }
       });
   };
 }

 export function getChaptersForReEvaluation(versionId, activityId, chapterId, questionId, firstLoadFlag, afterEvaluation) {

  return function (dispatch) {
    //dispatch(setBlockingState(true));
    axios
      .get("/evaluation/getChaptersForReEvaluation/" + versionId + "/" + activityId, {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
        }
      })
      .then(response => {
        //dispatch(setBlockingState(false));
        var nodeList = response.data;
        if (firstLoadFlag) {
          var chapt = nodeList[0];
          nodeList.map((node) => {
            node.toggled = true;
          })
          if (chapt) {
            var node = chapt.children;
            var question = node[0];
            if (question) {
              question.active = true;
              // chapt.toggled = true;
              dispatch(fetchEvaluationChapterSequence(question.mainQId));
              dispatch(getDealerMainQuestion(question.mainQId));
              dispatch(getSubQuestionForReEvaluation(question.mainQId, activityId));
            }
            else {
              //  node.toggled = true;
            }
          }
          dispatch({
            type: "FIRST_LOAD",
            payload: true
          });

        }
        else if (afterEvaluation) {
          for (var i = 0; i < nodeList.length; i++) {
            var chapt = nodeList[i];
            if (chapt.chapterId === chapterId) {
              var node = nodeList[i].children;
              for (var j = 0; j < node.length; j++) {
                var question = node[j];
                if (question.mainQId === questionId) {
                  question.active = true;
                }
                else {
                  question.active = false;
                }
              }
              chapt.toggled = true;
            }
            else {
              chapt.toggled = true;
            }

          }

        }
        else {
          if (chapterId && (questionId && questionId != 0)) {
            for (var i = 0; i < nodeList.length; i++) {
              var chapt = nodeList[i];
              if (chapt.chapterId === chapterId) {
                var node = nodeList[i].children;
                for (var j = 0; j < node.length; j++) {
                  var question = node[j];
                  if (question.mainQId === questionId) {
                    question.active = true;
                  }
                  else {
                    question.active = false;
                  }
                }
                chapt.toggled = true;
              }
              else {
                chapt.toggled = true;
              }

            }
            dispatch(fetchEvaluationChapterSequence(questionId));
            dispatch(getDealerMainQuestion(questionId));
            dispatch(getSubQuestionForReEvaluation(questionId, activityId));
          }
          else if (chapterId && !questionId) {
            for (var i = 0; i < nodeList.length; i++) {
              var node = nodeList[i];
              if (node.chapterId === chapterId) {
                node.active = true;
              }
              else {
                node.active = false;
              }
            }
          }
          else if (questionId && questionId === 0) {
          }
          else {
            dispatch(fetchEvaluationChapterSequence(null));
          }
        }

        dispatch({
          type: "EVALUATION_CHAPTERS",
          payload: nodeList
        });

      })
      .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          console.error(error);
        }
      });
  };
}


export function getSubQuestionForReEvaluation(questionId, activityId) {
  return function (dispatch) {
    //dispatch(setBlockingState(true));
      axios
        .get("/evaluation/getSubQuestionForReEvaluation/" + questionId + "/" + activityId, {
        headers: {
          'Authorization': 'Bearer ' + getToken(),
          Accept: "application/json",
          Pragma: "no-cache",
          "X-Frame-Options":"DENY"
        }
      })
      .then(response => {
        //dispatch(setBlockingState(false));
        var versionSubQuestionId = null;
        if (response.data.length > 0) {
          response.data.map((ele) => {
            if (ele.nmscSubQuestionId !== null && versionSubQuestionId === null) {
              versionSubQuestionId = ele.versionSubQuestionId;
            }
          })
        }
        if (versionSubQuestionId !== null) {
          dispatch(getNmscQuestionId(response.data[0].versionSubQuestionId))
        }
        dispatch({
          type: "EVALUATION_SUB_QUESTION",
          payload: response.data
        });
      })
      .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          console.error(error);
        }
      });
  };
}


export function completeReAudit(completeReAuditDto) {
 
  return function (dispatch) {
     axios
       .post("/activity/completeReAudit", completeReAuditDto,{
         headers: {
           'Authorization': 'Bearer ' + getToken(),
           Accept: "application/json",
           Pragma: "no-cache",
           "X-Frame-Options":"DENY"
         }
       })
       .then(response => {
         dispatch({
           type:"COMPLETE_REAUDIT" ,
           payload:response.data
         });
          if (response.data.statusCode === "200") {
                     toastr.success("Re Audit has been completed successfully");
          }
          dispatch(getReEvaluationProgressBar(completeReAuditDto.activityId));
          //fetching activity details on submit ReAudit to show the latest STATUS on screen
          dispatch(getActivityDetails(completeReAuditDto.activityId));
       })
       .catch(function (error) {
        if (error && error.status && (error.status === 429)) {
        } else {
          toastr.error("" + error);
        }
       });
   };
 }

 export function getEvaluationProgressBarForFirstAudit(activityId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getEvaluationProgressBarForFirstAudit/"+ activityId,null,"EVALUATION_PROGRESSBAR_FIRST"))
  };
  
}

 export function getEvaluationProgressBarForFirstAuditTME(activityId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getEvaluationProgressBarForFirstAuditTME/"+ activityId,null,"EVALUATION_PROGRESSBAR_FIRST_TME"))
  };
}

export function getReEvaluationProgressBarTME(activityId) {
  return function (dispatch) {
  dispatch(getCallWithReducer("/evaluation/getEvaluationProgressBarTME/"+ activityId,null,"RE_EVALUATION_PROGRESSBAR_TME"))
  };
}